<template>
  <div>
    <div
      class="display-3"
    >{{ type === 'edit' ? $t('categories.titleEdit') : $t('categories.titleCreate') }}</div>
    <div class="row row-equal align-center">
      <div class="flex md12">
        <div class="icon">
          <img v-if="icon" :src="icon" alt />
          <upload-photo :style="{ opacity: icon ? 0 : 1 }" :isLoading="false" @input="test" />
          <div class="display-5">{{ $t('categories.icon') }}</div>
        </div>
      </div>
      <div class="flex md12">
        <selector-category v-model="parent" :title="$t('categories.selectParent')" />
        <va-input v-model="name" :label="$t('categories.name')"></va-input>
        <va-button
          @click="submit"
          :disabled="isNotValidForm"
        >{{ type === 'edit' ? $t('categories.buttonEdit') : $t('categories.buttonCreate') }}</va-button>
      </div>
    </div>
  </div>
</template>
<script>

import SelectorCategory from './SelectorCategory.vue'
import UploadPhoto from './UploadPhoto.vue'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      icon: '',
      parent: 0,
      file: '',
      name: '',
    }
  },
  props: {
    type: String,
    default: () => 'create',
    validator(value) {
      return ['create', 'edit'].indexOf(value) !== -1
    },
  },
  components: {
    SelectorCategory,
    UploadPhoto,
  },
  computed: {
    isNotValidForm() {
      return !(this.parent && this.icon && this.name)
    },
  },
  methods: {
    ...mapActions('Categories', ['add']),
    submit() {
      const payload = new FormData()
      payload.append('name', this.name)
      payload.append('parent', this.parent)
      payload.append('icon', this.file)

      this.add(payload)
      this.icon = ''
      this.name = ''
    },
    test(file) {
      this.file = file
      const reader = new FileReader()
      reader.onloadend = () => {
        this.icon = reader.result
      }
      if (file) {
        reader.readAsDataURL(file)
      }
    },
  },
}
</script>
<style lang="scss">
.icon {
  position: relative;
  margin-bottom: 20px;

  img {
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    cursor: pointer;
    max-height: 100%;
    object-fit: cover;
  }
}
</style>
